import React from 'react';
import { compose, withHandlers, withPropsOnChange, withState } from 'recompose';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { keys } from 'lodash';
import { ApiClient } from 'services';
import { PendingButton } from 'components/common';
import { NotificationManager } from 'react-notifications';

const DeleteModal = ({ isOpen, toggle, numSelected, onConfirm, pending }) => (
  <Modal isOpen={isOpen} toggle={toggle}>
    <ModalBody>
      Are you sure you want to delete the {numSelected} selected row{numSelected >
      1
        ? 's'
        : ''}?
    </ModalBody>
    <ModalFooter>
      <PendingButton color="primary" pending={pending} onClick={onConfirm}>
        Confirm
      </PendingButton>{' '}
      <Button color="secondary" onClick={toggle}>
        Cancel
      </Button>
    </ModalFooter>
  </Modal>
);

const enhance = compose(
  withState('pending', 'setPending', false),
  withPropsOnChange(['selected'], ({ selected: tmpSelected }) => {
    const selected = keys(tmpSelected);

    return {
      numSelected: selected.length,
      selected,
    };
  }),
  withHandlers({
    onConfirm: ({
      onConfirm,
      url,
      deleteUrl='',
      selected,
      onDeleted,
      isOpen,
      toggle,
      setPending,
    }) => () => {
      const theUrl = deleteUrl != '' ? deleteUrl : url;
        
      setPending(true);
      let promise = null;
      const failed = [];
      if (onConfirm) {
        promise = onConfirm();
      } else {
        const client = ApiClient();

        promise = Promise.mapSeries(
          selected,
          i =>
            client.delete(`${theUrl}/${i}`).catch(() => {
              failed.push(i);
            }),
          { concurrency: 1 }
        ).tap(() => {
          if (failed.length) {
            NotificationManager.error(
              `${failed.length} row${
                failed.length > 1 ? 's' : ''
              } could not be deleted`
            );
          }
        });
      }

      promise
        .tap(() => {
          if (isOpen) toggle();
          onDeleted(failed.length ? failed : null);
        })
        .finally(() => setPending(false));
    },
  })
);

export default enhance(DeleteModal);



// WEBPACK FOOTER //
// ./src/components/common/Tables/DeleteModal.jsx